import axios from 'axios';
import { Category, CategoryFormData } from '../types/category';
import { API_BASE_URL } from '../config';

// استخدام رابط API من ملف الإعدادات
const API_URL = API_BASE_URL;
// يمكننا طباعة البيانات لتتبع المشكلة
const logAndReturn = (label: string, data: any) => {
  console.log(`[${label}]`, JSON.stringify(data, null, 2));
  return data;
};

// Get all categories
export const getCategories = async (): Promise<Category[]> => {
  const response = await axios.get(`${API_URL}/categories`, {
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': localStorage.getItem('token') || '',
    },
  });
  return response.data;
};

// Get single category by ID
export const getCategoryById = async (id: string): Promise<Category> => {
  const response = await axios.get(`${API_URL}/categories/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': localStorage.getItem('token') || '',
    },
  });
  return response.data;
};

// Create new category
export const createCategory = async (categoryData: CategoryFormData): Promise<Category> => {
  try {
    // طباعة البيانات المرسلة للتتبع
    console.log("Sending category data to API:", JSON.stringify(categoryData, null, 2));
    
    // تعديل الطلب لإرسال ضرائب بشكل صريح
    const dataToSend = {
      ...categoryData,
      taxes: categoryData.taxes || [] // تأكد أن الضرائب موجودة حتى لو كانت فارغة
    };
    
    const response = await axios.post(`${API_URL}/categories`, dataToSend, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': localStorage.getItem('token') || '',
      },
    });
    
    // طباعة البيانات المستلمة للتتبع
    console.log("Received category data from API:", JSON.stringify(response.data, null, 2));
    
    return response.data;
  } catch (error: any) {
    // Enhance error with additional details from response if available
    if (error.response && error.response.data) {
      error.field = error.response.data.field;
      error.details = error.response.data.details;
      error.customMessage = error.response.data.msg;
    }
    throw error;
  }
};

// Update existing category
export const updateCategory = async (id: string, categoryData: CategoryFormData): Promise<Category> => {
  try {
    // طباعة البيانات المرسلة للتتبع
    console.log(`Updating category ${id} with data:`, JSON.stringify(categoryData, null, 2));
    
    // تعديل الطلب لإرسال ضرائب بشكل صريح
    const dataToSend = {
      ...categoryData,
      taxes: categoryData.taxes || [] // تأكد أن الضرائب موجودة حتى لو كانت فارغة
    };
    
    const response = await axios.put(`${API_URL}/categories/${id}`, dataToSend, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': localStorage.getItem('token') || '',
      },
    });
    
    // طباعة البيانات المستلمة للتتبع
    console.log(`Updated category ${id} response:`, JSON.stringify(response.data, null, 2));
    
    return response.data;
  } catch (error: any) {
    // Enhance error with additional details from response if available
    if (error.response && error.response.data) {
      error.field = error.response.data.field;
      error.details = error.response.data.details;
      error.customMessage = error.response.data.msg;
    }
    throw error;
  }
};

// Delete category
export const deleteCategory = async (id: string): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/categories/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': localStorage.getItem('token') || '',
      },
    });
  } catch (error: any) {
    // Enhance error with additional details from response if available
    if (error.response && error.response.data) {
      error.field = error.response.data.field;
      error.details = error.response.data.details;
      error.customMessage = error.response.data.msg;
    }
    throw error;
  }
};